// extracted by mini-css-extract-plugin
export default {"qNumber":"answer_qNumber__eCgR7","question":"answer_question__QiuS3"};